// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16iTD","colMin":"styles_colMin__4hDLa"};